import http from "plugins/axios";

export default {
  /** 查询用户合约交易与资产监控时间段汇总列表。 */
  getSummaryList(data) {
    return http.post({
      url: "/ta/admin/user/contractAssetMonitor/list",
      data,
    });
  },
  /** 导出筛选后的全部时间段汇总数据。 */
  exportSummary(data) {
    return http.post({
      url: "/ta/admin/user/contractAssetMonitor/export",
      data,
      responseType: "blob",
    });
  },
  /** 按“用户 + 统计日期”分页查询每日明细。 */
  getDailyList(data) {
    return http.post({
      url: "/ta/admin/user/contractAssetMonitor/daily/list",
      data,
    });
  },
  /** 导出筛选后的全部每日明细数据。 */
  exportDaily(data) {
    return http.post({
      url: "/ta/admin/user/contractAssetMonitor/daily/export",
      data,
      responseType: "blob",
    });
  },
  /** 查询指定UID的实时现货账户余额明细。 */
  getSpotBalanceDetails(data) {
    return http.post({
      url: "/ta/admin/user/contractAssetMonitor/spotBalance/detail",
      data,
    });
  },
  /** 查询指定UID在筛选时间段内的充值成功明细。 */
  getDepositDetails(data) {
    return http.post({
      url: "/ta/admin/user/contractAssetMonitor/deposit/detail",
      data,
    });
  },
  /** 查询指定UID在筛选时间段内的提现成功明细。 */
  getWithdrawDetails(data) {
    return http.post({
      url: "/ta/admin/user/contractAssetMonitor/withdraw/detail",
      data,
    });
  },
  /** 按币种查询指定UID在筛选时间段内的净充值明细。 */
  getNetDepositDetails(data) {
    return http.post({
      url: "/ta/admin/user/contractAssetMonitor/netDeposit/detail",
      data,
    });
  },
  /** 按合伙人查询指定UID在筛选时间段内产生的贡献返佣明细。 */
  getContributionRebateDetails(data) {
    return http.post({
      url: "/ta/admin/user/contractAssetMonitor/contributionRebate/detail",
      data,
    });
  },
  /** 按下级用户查询当前合伙人在筛选时间段内获得的贡献返佣明细。 */
  getSubordinateContributionDetails(data) {
    return http.post({
      url: "/ta/admin/user/contractAssetMonitor/subordinateContribution/detail",
      data,
    });
  },
};
